import React, { useEffect } from 'react'
import Gateways from '../gateways/Gateways'
// import './style.css'
// import WalletImage from './assets/Wallet.png'
// import UPIImage from './assets/UPI.png'
// import DebitImage from './assets/Debit Card.png'
// import Creditimage from './assets/Credit Card.png'
// import NetImage from './assets/Net Banking.png'
// import CryptoImage from './assets/Crypto.png'
// import PaypalImage from './assets/PayPal.png'
// import { Bounce, toast } from 'react-toastify'

// const getEnvironmentUrl = (env: string) => {
//   const baseUrls: any = {
//     local: 'http://localhost:8002',
//     qa: 'https://qa-ks-pay-openapi.p2eppl.com',
//     dev: 'https://dev-ks-pay-openapi.p2eppl.com',
//     SANDBOX: 'https://pay-open-sandboxapi.kalp.studio',
//     LIVE: 'https://pay-open-liveapi.kalp.studio',
//   }
//   return baseUrls[env]
// }

export default function PaymentMethod({ payload }: any) {
  // debugger;
  if (!payload) {
    alert('err')
  }
  useEffect(() => {
    // let path=window.location.pathname
    // window.history.pushState({}, '', '/pay')

    const handlePop = () => {
      //   const confirmLeave = window.confirm("Are you sure you want to leave this page?");
      //   if (!confirmLeave){
      // window.history.pushState({}, '', '/pay');

      //     // window.history.replaceState({}, '', '/pay');
      //     return;
      //   } else{

      //   }
      window.location.reload()
    }

    window.addEventListener('popstate', handlePop)
    return () => {
      window.removeEventListener('popstate', handlePop)
    }
  }, [])
  // headers.environment_url = getEnvironmentUrl(headers?.environment)

  // const [allPaymentMethod, setAllPaymentMethod] = useState([])
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
  // const [isSubmit, setIsSubmit] = React.useState(false)

  // const handlePaymentMethodChange = (e: any) => {
  //   setSelectedPaymentMethod(e)
  //   payload.paymentMethodId = e
  // }

  // const getPaymentMethod = async () => {
  //   try {
  //     let res = await getMethod(payload?.currencyId, headers)
  //     setAllPaymentMethod(res)
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }
  // useEffect(() => {
  //   getPaymentMethod()
  // }, [])
  // const handleCheckout = () => {
  //   if (selectedPaymentMethod != null) {
  //     setIsSubmit(true)
  //   } else {
  //     toast.error('Please select payment method', {
  //       position: 'top-right',
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: 'light',
  //       transition: Bounce,
  //     })
  //   }
  // }
  // const renderMehtod = () => {
  //   return allPaymentMethod?.map((method: any) => {
  //     if (method?.name === 'WALLET') {
  //       return (
  //         <img
  //           src={WalletImage}
  //           alt='Wallet'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     } else if (method?.name === 'UPI') {
  //       return (
  //         <img
  //           src={UPIImage}
  //           alt='Upi'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     if (method?.name === 'CREDIT CARD') {
  //       return (
  //         <img
  //           src={Creditimage}
  //           alt='Credit card'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     if (method?.name === 'DEBIT CARD') {
  //       return (
  //         <img
  //           src={DebitImage}
  //           alt='Debit card'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     if (method?.name === 'NET BANKING') {
  //       return (
  //         <img
  //           src={NetImage}
  //           alt='Net Banking'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     if (method?.name === 'CRYPTO') {
  //       return (
  //         <img
  //           src={CryptoImage}
  //           alt='Crypto'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     if (method?.name === 'PAYPAL') {
  //       return (
  //         <img
  //           src={PaypalImage}
  //           alt='Paypal'
  //           onClick={() => handlePaymentMethodChange(method.id)}
  //           style={
  //             selectedPaymentMethod === method.id
  //               ? { border: '2px solid #0000ff61', borderRadius: 10 }
  //               : { cursor: 'pointer' }
  //           }
  //         />
  //       )
  //     }
  //     return null // Return null for other methods
  //   })
  // }

  return (
    <div>
      {/* {isSubmit ? (
        <Gateways payload={payload} headers={headers} transactionStatusCallback={transactionStatusCallback} />
      ) : (
        <>
          {/* <div className="payment-method-container">
        <label>Select Payment Method: </label>
        <select value={selectedPaymentMethod||''} onChange={handlePaymentMethodChange} className="payment-method-dropdown">
          <option value="">-- Select Payment Method --</option>
          {
            allPaymentMethod.map((method:any)=>
              <option key={method?.id} value={method?.id}>{method?.name}</option>
            )
          }
        </select>
      </div> */}
         {/*} <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                height: '100vh',
                flexDirection: 'column',
              }}
            >
              <label>Select Payment Method: </label>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '1rem',
                  flexWrap: 'wrap',
                }}
              >
                {allPaymentMethod?.length > 0 && renderMehtod()}
              </div>
              <button onClick={handleCheckout} className='checkout-button'>
                Pay
              </button>
            </div>
          </>
        </>
      )} */}
        <Gateways payload={payload}/>

    </div>
  )
}
